<template>
  <div v-bind:class="{
      'dispatch-notification': true,
      warning: !notification.accept,
      success: notification.accept,
      hide: !notification.show
    }">
    <div class="message" v-if="notification.isSendAsSchedule && notification.sendAsScheduleError !== ''">
      <span class="error-title">ERROR: Send as schedule</span>
      <span>{{ notification.sendAsScheduleError }}</span>
    </div>
    <div class="message" v-else-if="notification.runsDeclined">
      <span>
        Driver rejected Run #{{notification.id}}
        (<span v-for="(rsvp, i) in notification.sendAsScheduleError" :key="i"> 
          <span v-if="i != 0">,</span>
          <a :href="'/#/reservation/' + rsvp" target="_blank">{{ rsvp }}</a>
        </span>)
      </span>
    </div>
    <div class="message" v-else>
      <span v-if="notification.driverId !== ''">
        Driver
        <a :href="'/#/provider/' + notification.driverId" target="_blank">{{ notification.driverName }}</a>
        <span v-show="notification.accept">accepted</span>
        <span v-show="!notification.accept">rejected</span>
      </span>
      <span v-else-if="!isSendAsSchedule">Sorry but we did not find any drivers for</span>
      <span v-if="!isSendAsSchedule">
        <span v-show="notification.isPackage">package</span>
        <span v-show="!notification.isPackage">reservation</span>
        <a :href="'/#/reservation/' + notification.id" target="_blank">{{ notification.id }}</a>.
      </span>

      <span v-else>
        <span v-if="sendAsScheduleData.rsvp.length">
          reservation<span v-if="sendAsScheduleData.rsvp.length > 1">s</span>
          <span v-for="(rsvp, index) in sendAsScheduleData.rsvp">
            <a :href="'/#/reservation/' + rsvp">{{ rsvp }}</a><span
              v-if="index < sendAsScheduleData.rsvp.length - 1" class="comma">,</span>
          </span>
        </span>
        <span v-if="sendAsScheduleData.rsvp.length > 0 && sendAsScheduleData.pkg.length > 0"> and </span>
        <span v-if="sendAsScheduleData.pkg.length">
          package<span v-if="sendAsScheduleData.pkg.length > 1">s</span>
          <span v-for="(pkg, index) in sendAsScheduleData.pkg">
            <a :href="'/#/package/' + pkg">{{ pkg }}</a><span
              v-if="index < sendAsScheduleData.pkg.length - 1" class="comma">,</span>
          </span>
        </span>
      </span>

    </div>
    <a class="button xsmall" href="javascript:;" @click="close">CLOSE</a>
  </div>
</template>

<script>
export default {
  name: 'dispatch-notification',
  computed: {
    notification () { return this.$store.state.dispatch.acceptNotification },
    isSendAsSchedule () { return this.notification.isSendAsSchedule },
    sendAsScheduleData () { return this.$store.state.dispatch.schedule }
  },
  methods: {
    close () { this.$store.commit('dispatch/hideDispatchAcceptNotification') }
  }
}
</script>

<style lang="scss" scoped>
.dispatch-notification {
  position: fixed;
  z-index: 999;
  top: 15px;
  right: 15px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.5);
  padding: 15px;
  border-radius: 3px;
  text-align: right;
  transition: all 250ms;

  &.hide { top: -130px }

  &.success { border-top: 5px solid #26D97A; }
  &.warning { border-top: 5px solid #F25E0D; }

  & .message {
    font-size: 14px;
    color: #333;
    font-weight: 700;
    text-align: center;
  }

  .error-title {
    font-size: 16px;
    display: block;
    color: #F25E0D;
  }
  .comma {
    display: inline-block;
    margin-right: 4px;
  }

  & .button {
    margin-top: 10px;
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dispatch/DispatchNotification.vue